import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "regenerator-runtime/runtime";
import _uniq from "lodash/uniq";
import _each from "lodash/each";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { getJSONFromCookie } from '../../helpers/cookie-helpers';
import nrAwareErrorHandler from '../../helpers/nr-aware-error-handler';
import { CompareCardIdListCookieName } from './cookie-names';
import { setComparedCardIdsAndData } from './compare';
import getCardDataFromOfferApi from './get-card-data-from-offer-api';
/**
 * Given a list of cards, creates a map with the card-id as key and card as the value.
 *
 * @example
 * ```
 * makeCardDataMap([{id: 111, slu…}, {id: 222, slu…}, { id: 333, slu…}]);
 * // Will return {
 * //   111: { id… },
 * //   222: { id… },
 * //   333: { id… },
 * // }
 * ```
 *
 * @function
 * @param {Object[]} - list of cards.
 * @returns {Object<number, Object>} - a map with the card-id as key and card as the value.
 */

var makeCardDataMap = function makeCardDataMap(cards) {
  var idToCardMap = {};

  _each(cards, function (card) {
    return idToCardMap[card.id] = card;
  }); // eslint-disable-line no-return-assign, max-len


  return idToCardMap;
};
/* eslint-disable max-len */

/**
 * Sets legacy-id and data for all the cards that need to be compared into the store.
 *
 * Hits the offer-api to obtain card-data, and converts it to the legacy card format.
 *
 * The nodeapp using this action must supply its own instance of offerSDK.
 *
 * @function
 * @param {Object} opts -
 * @param {OfferSDK} opts.offerSDK - an already initialised offer-sdk instance.
 * @param {Request} [opts.serverRequest] - Required when calling from the server-side.
 * @return {ActionCreator} - an action creator that returns a promise, which will resolve when the
 *    card data has been obtained and set into the store.
 */


var addCompareCookie = function addCompareCookie(_ref) {
  var offerSDK = _ref.offerSDK,
      serverRequest = _ref.serverRequest;
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(dispatch) {
        var cardIDs, cards;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.t0 = _uniq;
                _context.next = 4;
                return getJSONFromCookie(CompareCardIdListCookieName, [], serverRequest);

              case 4:
                _context.t1 = _context.sent;
                cardIDs = (0, _context.t0)(_context.t1);
                _context.next = 8;
                return dispatch(getCardDataFromOfferApi(offerSDK, cardIDs));

              case 8:
                cards = _context.sent;
                dispatch(setComparedCardIdsAndData(cardIDs, makeCardDataMap(cards)));
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t2 = _context["catch"](0);
                nrAwareErrorHandler(_context.t2);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 12]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
};
/* eslint-enable max-len */


export default addCompareCookie;
//# sourceMappingURL=addCompareCookie.js.map